"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTAREA = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const cell_editor_1 = require("./cell-editor");
const text_1 = require("./text");
const TEXTAREA_FORMATTER_CONFIG = text_1.TEXT.formatter.schema.extend({});
const TEXTAREA_EDITOR_CONFIG = text_1.TEXT.editor.schema.extend({
    rows: z
        .number()
        .optional()
        .default(1)
});
exports.TEXTAREA = {
    name: 'textarea',
    formatter: {
        schema: TEXTAREA_FORMATTER_CONFIG,
        createComponent(config) {
            return text_1.TEXT.formatter.createComponent(config);
        }
    },
    editor: {
        schema: TEXTAREA_EDITOR_CONFIG,
        createComponent(config) {
            return {
                component: {
                    name: 'TextareaEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<b-form-textarea
              v-model="currentValue"
              v-bind="bindings"
              :id="col.field"
              :name="col.name"
              :tabindex="col.effectiveTabindex"
              :form="formId"
              :size="col.size"
              :state="validationState"
              :disabled="isDisabled"
              @change="onChange($event)"
            ></b-form-textarea>`),
                    data() {
                        return {
                            bindings: {
                                autocomplete: config.autocomplete,
                                placeholder: config.placeholder,
                                rows: config.rows
                            }
                        };
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=textarea.js.map